import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { AuthRepository } from 'src/app/state/auth.repository';
import { AuthService } from 'src/app/state/auth.service';
import { UiRepository } from 'src/app/state/ui.repository';
import { EnvState } from './modules/shared/helpers/env-state';
import { ConnectionService } from './modules/shared/services/connection.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy {
  sessionRefreshSubscription = this.auth
    .autoRefresh()
    .subscribe(() => console.info('Session refreshed'));
  sessionExpiredSubscription = this.authRepo.isExpired$.subscribe(() => {
    if (!this.router.url.startsWith('/signin')) {
      this.ui.setSessionOver();
    }
  });
  menuOpenedSubscription = this.ui.isMenuOpened$.subscribe((val) =>
    this.switchClass('body', 'menu-open', val)
  );
  menuExpandedSubscription = this.ui.isMenuExpanded$.subscribe((val) =>
    this.switchClass('body', 'menu-expanded', val)
  );
  userRoleSubscription = this.authRepo.roles$.subscribe((roles) => {
    let body = document.getElementsByTagName('body')[0];
    body.classList.forEach((element) => {
      if (element.startsWith('user-role-')) {
        body.classList.remove(element);
      }
    });
    roles.forEach((role) =>
      body.classList.add(`user-role-${role.toLocaleLowerCase()}`)
    );
  });

  isSessionRefreshModalDisplayed$ = combineLatest([
    this.ui.isSessionOver$,
    this.connection.isOnline$,
  ]).pipe(map(([sesionOver, online]) => sesionOver && online));

  features = this.env.features;

  constructor(
    private ui: UiRepository,
    private auth: AuthService,
    private authRepo: AuthRepository,
    private router: Router,
    public env: EnvState,
    private connection: ConnectionService
  ) {
    authRepo.claims$.subscribe((x) => {
      if (!x['acs']) {
        this.logout();
      }
    });
  }

  logout() {
    this.menuclose();
    this.auth.logout().subscribe(() => this.router.navigate(['/signin']));
    return false; // prevent default
  }

  menuclose(tenantId?: string) {
    this.ui.toggleMenuOpened(false, tenantId);
  }

  ngOnDestroy(): void {
    this.sessionRefreshSubscription.unsubscribe();
    this.sessionExpiredSubscription.unsubscribe();
    this.menuOpenedSubscription.unsubscribe();
    this.menuExpandedSubscription.unsubscribe();
    this.userRoleSubscription.unsubscribe();
  }

  switchClass(element: string, className: string, enabled: boolean) {
    let elem = document.getElementsByTagName(element)[0];
    if (enabled) {
      elem.classList.add(className);
    } else {
      elem.classList.remove(className);
    }
  }

  resolveActionTitle(relativeUrl: string, body: any, method: string) {
    const urlSegments = relativeUrl.split('/');
    const firstSegment = urlSegments[0];
    let actionNameTitleCase =
      firstSegment.charAt(0).toUpperCase() + firstSegment.substring(1);
    return `${actionNameTitleCase}: ${method === 'POST' ? 'add' : 'edit'}`;
  }
}
